import React from 'react'
import { Row, Col, Tag, Avatar, Empty } from 'antd'
import {
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons'
import { getStoredUser, canViewModule, getRoleDisplayLabel } from '../utils/permissionUtils'

const MODULE_KEY = 'profile'

const Profile = () => {
  const user = getStoredUser()

  if (!canViewModule(MODULE_KEY)) {
    return (
      <div className="page-shell user-master-page">
        <div className="page-empty">
          <Empty description="No permission to view profile" />
        </div>
      </div>
    )
  }

  return (
    <div className="page-shell user-master-page">
      <div className="user-page-header">
        <div className="user-page-header-left">
          <div className="user-page-icon">
            <UserOutlined />
          </div>

          <div>
            <h2 className="user-page-title">Profile</h2>
            <p className="user-page-subtitle">
              View your account details and role information.
            </p>
          </div>
        </div>
      </div>

      <div className="page-card table-card profile-page-card">
        <div className="profile-top-section">
          <div className="profile-user-block">
            <Avatar size={78} icon={<UserOutlined />} className="profile-avatar" />
            <div className="profile-user-content">
              <h3 className="profile-user-name">{user?.full_name || '-'}</h3>
              <p className="profile-user-role">{getRoleDisplayLabel(user?.role)}</p>
              <div className="profile-status-wrap">
                <Tag color={String(user?.status || '').toLowerCase() === 'active' ? 'green' : 'red'}>
                  {user?.status || '-'}
                </Tag>
              </div>
            </div>
          </div>
        </div>

        <div className="table-card-header">
          <div>
            <h3>User Information</h3>
            <p>Your basic profile details are shown below.</p>
          </div>
        </div>

        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <div className="payment-box profile-info-box">
              <div className="profile-info-head">
                <div className="stats-card-icon blue">
                  <UserOutlined />
                </div>
                <div>
                  <div className="payment-box-title">Full Name</div>
                  <div className="payment-box-value profile-value-text">
                    {user?.full_name || '-'}
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <div className="payment-box profile-info-box">
              <div className="profile-info-head">
                <div className="stats-card-icon green">
                  <SafetyCertificateOutlined />
                </div>
                <div>
                  <div className="payment-box-title">Role</div>
                  <div className="payment-box-value profile-value-text">
                    {getRoleDisplayLabel(user?.role)}
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <div className="payment-box profile-info-box">
              <div className="profile-info-head">
                <div className="stats-card-icon blue">
                  <MailOutlined />
                </div>
                <div>
                  <div className="payment-box-title">Email</div>
                  <div className="payment-box-value profile-value-text profile-break">
                    {user?.email || '-'}
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <div className="payment-box profile-info-box">
              <div className="profile-info-head">
                <div className="stats-card-icon red">
                  <PhoneOutlined />
                </div>
                <div>
                  <div className="payment-box-title">Phone</div>
                  <div className="payment-box-value profile-value-text">
                    {user?.phone || '-'}
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <div className="payment-box profile-info-box">
              <div className="payment-box-title">Username</div>
              <div className="payment-box-value profile-value-text">
                {user?.username || '-'}
              </div>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <div className="payment-box profile-info-box">
              <div className="payment-box-title">User ID</div>
              <div className="payment-box-value profile-value-text">
                {user?.user_id || '-'}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Profile